const HouseRowIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
    >
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
        d='M13.5 6H17v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 1 15V6h3.5m6.75 10.5v-6h-4.5v6m6.75 0V2.75h-9V16.5'
      />
    </svg>
  );
};

export default HouseRowIcon;
